import Vue from "vue";
import Vuex from "vuex";

// Modules
// import ecommerceStoreModule from '@/views/apps/e-commerce/eCommerceStoreModule'
import app from "./app";
import appConfig from "./app-config";
import verticalMenu from "./vertical-menu";
import userPersonalSidebar from "./user-personal-sidebar";
import search from "./search";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    app,
    appConfig,
    verticalMenu,
    userPersonalSidebar,
    search,
  },
  strict: process.env.DEV,
});
